// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__N86fT","title":"text__title__zzRDF","body":"text__body__dvu6Q","img":"text__img__Su7w3"};